import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const NavBar = (props) => {
    const [username, setUser] = useState('');
    const [showBlogs, setShowBlogs] = useState(false);
    const [email, setEmail] = useState('');
    const [newBlog, setNewBlog] = useState(false);
    const [id, setId] = useState('');
    const [icon, setIcon] = useState(null);
    
    const navigate = useNavigate();

    const company = Cookies.get(`token_company`);
    const email_user = Cookies.get(`token_email`);
    const firstname = Cookies.get(`token_first_name`);
    const lastname = Cookies.get(`token_last_name`);
    const phone = Cookies.get(`token_phone`);

    if (firstname || lastname || company || email_user || phone) {
        return (
            <div className="border-bottom mb-3">

            

            <nav className="navbar navbar-expand-sm">
                <div className="container-fluid">
                    <Link to="/" className="navbar-brand">
                        <span className="d-flex align-items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-tree-fill text-primary" viewBox="0 0 16 16">
                        <path d="M8.416.223a.5.5 0 0 0-.832 0l-3 4.5A.5.5 0 0 0 5 5.5h.098L3.076 8.735A.5.5 0 0 0 3.5 9.5h.191l-1.638 3.276a.5.5 0 0 0 .447.724H7V16h2v-2.5h4.5a.5.5 0 0 0 .447-.724L12.31 9.5h.191a.5.5 0 0 0 .424-.765L10.902 5.5H11a.5.5 0 0 0 .416-.777l-3-4.5z"/>
                        </svg>
                        <h3 className="display-6 text-primary d-inline-block m-0 "> 
                            Apple-Tree
                            </h3>
                        </span>
                        
                        
                    </Link>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#main-nav" aria-controls="main-nav" aria-expanded="fals" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                    </button>
                
            
                <div id="main-nav" className=" me-3 collapse navbar-collapse justify-content-end align-center">
                    <ul className="navbar-nav">
                        <li className="nav-item">
                            <a href="/login" className="nav-link" onClick={(e) => {
                                e.preventDefault()
                                Cookies.remove(`token_company`);
                                Cookies.remove(`token_email`);
                                Cookies.remove(`token_first_name`);
                                Cookies.remove(`token_last_name`);
                                Cookies.remove(`token_phone`);
                                navigate('/login')
                            }}>
                                Log out
                            </a>
                        </li>
                        <li className="nav-item">
                            <a href="/login" className="nav-link" onClick={(e) => {
                                e.preventDefault()
                                navigate('/dashboard')
                            }}>
                                Dashboard
                            </a>
                        </li>
                        
                    </ul>
                </div>
                </div>
            </nav>
            
        </div>
        )
    }
    
    return ( 

        <div className="border-bottom mb-3">

            

            <nav className="navbar navbar-expand-sm">
                <div className="container-fluid">
                    <Link to="/" className="navbar-brand">
                        <span className="d-flex align-items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-tree-fill text-primary" viewBox="0 0 16 16">
                        <path d="M8.416.223a.5.5 0 0 0-.832 0l-3 4.5A.5.5 0 0 0 5 5.5h.098L3.076 8.735A.5.5 0 0 0 3.5 9.5h.191l-1.638 3.276a.5.5 0 0 0 .447.724H7V16h2v-2.5h4.5a.5.5 0 0 0 .447-.724L12.31 9.5h.191a.5.5 0 0 0 .424-.765L10.902 5.5H11a.5.5 0 0 0 .416-.777l-3-4.5z"/>
                        </svg>
                        <h3 className="display-6 text-primary d-inline-block m-0 "> 
                            Apple-Tree
                            </h3>
                        </span>
                        
                        
                    </Link>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#main-nav" aria-controls="main-nav" aria-expanded="fals" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                    </button>
                
            
                <div id="main-nav" className=" me-3 collapse navbar-collapse justify-content-end align-center">
                    <ul className="navbar-nav">
                        <li className="nav-item">
                            <Link to="/register" className="nav-link">
                                Register
                            </Link>
                        </li>
                            <li className=" nav-link">
                                |
                            </li>
                        <li className="nav-item">
                            <Link to="/login" className="nav-link">
                                Login
                            </Link>
                        </li>
                            <li className=" nav-link">
                                |
                            </li>
                        <li className="nav-item">
                            <a href="/login" className="nav-link" onClick={(e) => {
                                e.preventDefault()
                                Cookies.removeItem(`token_company`);
                                Cookies.removeItem(`token_email`);
                                Cookies.removeItem(`token_first_name`);
                                Cookies.removeItem(`token_last_name`);
                                Cookies.removeItem(`token_phone`);
                                navigate('/login')
                            }}>
                                Log out
                            </a>
                        </li>
                        
                    </ul>
                </div>
                </div>
            </nav>
            
        </div>
     );
}
 
export default NavBar;